import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { pricingPlans } from '../data/mock';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Pricing = () => {
  const navigate = useNavigate();

  const handleGetStarted = (plan) => {
    navigate('/checkout', { state: { package: plan } });
  };

  return (
    <>
    <section className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center shadow-lg shadow-purple-500/50">
              <div className="w-4 h-4 bg-white rounded-sm"></div>
            </div>
            <span className="text-purple-400 font-semibold uppercase tracking-wider text-sm">
              OUR PRICING
            </span>
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4"
            style={{ letterSpacing: '0.1em' }}
          >
            Plans Built For Growth
          </h2>
          <div className="h-1 w-32 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto rounded-full"></div>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {pricingPlans.map((plan, index) => {
            const Icon = LucideIcons[plan.icon];
            return (
              <div
                key={plan.id}
                className={`relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl shadow-xl border ${
                  plan.featured ? 'ring-2 ring-purple-500 transform scale-105 border-purple-500/50' : 'border-purple-500/20'
                } hover:shadow-2xl hover:shadow-purple-900/50 transition-all duration-300 flex flex-col`}
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.2}s both`
                }}
              >
                {plan.featured && (
                  <div className="absolute top-0 right-0 bg-gradient-to-r from-purple-600 to-blue-600 text-white px-4 py-1 text-sm font-semibold shadow-lg z-10">
                    POPULAR
                  </div>
                )}

                {/* Fixed Header Section */}
                <div className="p-8 pb-4 flex-shrink-0">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-blue-600 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-purple-500/50">
                    {Icon && <Icon className="h-8 w-8 text-white" />}
                  </div>

                  {/* Price */}
                  <div className="mb-6">
                    <div className="flex items-baseline">
                      <span className="text-5xl font-bold bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">${plan.price}</span>
                    </div>
                    <h3 className="text-xl font-bold text-white mt-2">{plan.name}</h3>
                  </div>

                  {/* Description */}
                  <p className="text-gray-400 mb-6">{plan.description}</p>

                  {/* CTA Button */}
                  <Button
                    onClick={() => handleGetStarted(plan)}
                    className={`w-full py-6 rounded-full font-semibold ${
                      plan.featured
                        ? 'bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white shadow-lg shadow-purple-500/50'
                        : 'bg-gray-700 hover:bg-gray-600 text-white'
                    }`}
                  >
                    Get Started
                  </Button>
                </div>

                {/* Scrollable Details Section */}
                <div className="px-8 pb-8 overflow-y-auto scrollbar-thin scrollbar-thumb-purple-600 scrollbar-track-gray-800 hover:scrollbar-thumb-purple-500" style={{ maxHeight: '350px' }}>
                  {/* Features List */}
                  <ul className="space-y-3">
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start space-x-3">
                        <Check className="h-5 w-5 text-purple-400 flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-gray-400">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Value Added Services */}
                  <div className="mt-6 pt-6 border-t border-gray-700">
                    <p className="text-sm font-semibold text-white mb-3">Value Added Services</p>
                    <ul className="space-y-2">
                      {plan.valueAdded.map((item, idx) => (
                        <li key={idx} className="text-xs text-gray-500">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Decorative element */}
                <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-purple-600/20 rounded-full opacity-50 blur-2xl"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
    </>
  );
};

export default Pricing;